module.exports = __webpack_public_path__ + "img/enquiry-fab-en.806f2b1.png";